import placesData from './data/places.json';

export const places = placesData.places;

export function getAllPhotos() {
  return places.flatMap((place) =>
    place.photos.map((photo) => ({
      ...photo,
      placeId: place.id,
      placeName: place.name,
      placeLongitude: place.longitude,
      placeLatitude: place.latitude,
      placeZoom: place.zoom,
    }))
  );
}

export function findPhoto(photoId) {
  return getAllPhotos().find((photo) => photo.id === photoId);
}

export function findPlace(placeId) {
  return places.find((place) => place.id === placeId);
}
